
      import Qq from './qq.vue'
      import type { App, Plugin } from 'vue'

      export const QqPlugin: Plugin = {
        install(app: App) {
          app.component('Qq', Qq)
        },
      }
      export { Qq }
      